/* import __COLOCATED_TEMPLATE__ from './tag.hbs.js'; */
import Component from '@glimmer/component';
export default class Tag extends Component {
  get width() {
    return this.args.width ?? 24;
  }
  get height() {
    return this.args.height ?? 24;
  }
  get fill() {
    return this.args.fill ?? 'black';
  }
  get fillOpacity() {
    return this.args.fillOpacity ?? 1;
  }
  get viewBox() {
    return this.args.viewBox ?? '8 8 24 24';
  }
}